import React from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Snackbar,
  Stack,
  Typography,
  CloseIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const SampleSnackbar = () => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Simple snackbars
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          A basic snackbar that aims to reproduce Google Keep's snackbar
          behavior.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              "  const [open, setOpen] = React.useState(false);\n" +
              "\n" +
              "  const handleClick = () => {\n" +
              "    setOpen(true);\n" +
              "  };\n" +
              "\n" +
              "  const handleClose = (event, reason) => {\n" +
              '    if (reason === "clickaway") {\n' +
              "      return;\n" +
              "    }\n" +
              "\n" +
              "    setOpen(false);\n" +
              "  };\n" +
              "\n" +
              "  const action = (\n" +
              "    <React.Fragment>\n" +
              '      <Button color="secondary" size="small" onClick={handleClose}>\n' +
              "        UNDO\n" +
              "      </Button>\n" +
              "      <IconButton\n" +
              '        size="small"\n' +
              '        aria-label="close"\n' +
              '        color="inherit"\n' +
              "        onClick={handleClose}\n" +
              "      >\n" +
              '        <CloseIcon fontSize="small" />\n' +
              "      </IconButton>\n" +
              "    </React.Fragment>\n" +
              "  );\n" +
              "\n" +
              "  return (\n" +
              "    <>\n" +
              "      <Button onClick={handleClick}>Open simple snackbar</Button>\n" +
              "      <Snackbar\n" +
              "        open={open}\n" +
              "        autoHideDuration={6000}\n" +
              "        onClose={handleClose}\n" +
              '        message="Note archived"\n' +
              "        action={action}\n" +
              "      />\n" +
              "    </>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <Button onClick={handleClick}>Open simple snackbar</Button>
            <Snackbar
              open={open}
              autoHideDuration={6000}
              onClose={handleClose}
              message="Note archived"
              action={action}
            />
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default SampleSnackbar;
